const defaultState = {
  id: null,
  email: null
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case "AUTH_RESPONSE":
      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js